// Step 2
// Personal user Details

import React from "react";
import InputFields from "../../common/input";
import CardAsset from "../UI/card-asset";
import StepsIndicator from "../steps-indicator";
import NextButton from "../../components/UI/next-button";
import BackButton from "../UI/back-button";
import AllLoginNotification from "../../components/UI/all-login-notif-card";
import Cookies from "js-cookie";
import Layout from "../layout";
import ErrorBoundary from "../errors/ErrorBoundary";

export default function PersonalDetailStep({
  languages,
  currentStep,
  taxNumberIN,
  locationData,
  inputPersonalEl,
  stepNo,
  inputFields,
  personalDetailsSubmit,
  inputChange,
  inputPhoneChange,
  onFieldBlur,
  emailChecking,
  goPreviousStep,

  isProcessing,
  goNextStep,
  isDisabled,
}) {
  console.log(currentStep);
  console.log(stepNo);
  console.log(inputFields);
  if (currentStep !== stepNo) {
    return null;
  }

  const memberFirst = inputFields.find(
    (field) => field.name === "first_name"
  )?.value;
  const memberLast = inputFields.find(
    (field) => field.name === "last_name"
  )?.value;

  const isUserLoggedIn =
    Cookies.get("accorUserData") || Cookies.get("allUserData");

  return (
    <Layout>
      <ErrorBoundary>
        {/* Grid Layout for CardAsset and Form */}
        <div className="grid grid-cols-1 tablet:grid-cols-2 tablet:gap-4">
          {/* Left Column: CardAsset */}
          <div className="flex flex-col mx-auto xs:mx-0">
            <BackButton goPreviousStep={goPreviousStep} />
            <CardAsset />
          </div>

          {/* Right Column: Form */}
          <div className="xs:flex xs:justify-center xs:flex-col w-[420px] xs:w-auto">
            <StepsIndicator
              step={currentStep}
              stepText={
                languages && languages.stepTitle2
                  ? languages.stepTitle2
                  : "Contact Details"
              }
              subTitleHeader={
                languages && languages.yourContactDetails
                  ? languages.yourContactDetails
                  : "Your contact details"
              }
              languages={languages}
            />

            {!isUserLoggedIn ? (
              <AllLoginNotification languages={languages} />
            ) : null}

            <form
              id="personal-details"
              className="tablet:px-4 input-borders py-4 xs:w-full mt-5"
            >
              <InputFields
                languages={languages}
                inputFields={inputFields}
                inputChange={inputChange}
                inputPhoneChange={inputPhoneChange}
                onFieldBlur={onFieldBlur}
                inputEl={inputPersonalEl}
                locationData={locationData}
                taxNumberIN={taxNumberIN}
                emailChecking={emailChecking}
              />
            </form>
            <NextButton
              isProcessing={isProcessing}
              goNextStep={goNextStep}
              languages={languages}
              isDisabled={isDisabled}
            />
          </div>
        </div>
      </ErrorBoundary>
    </Layout>
  );
}
